import { Component, computed, inject } from '@angular/core';
import { CurrencyPipe, NgStyle } from '@angular/common';
import { LanguageService } from 'src/app/services/language.service';
import { FormService } from 'src/app/services/form.service';
import { StepsService } from 'src/app/services/steps.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-price-state',
    imports: [CurrencyPipe, TranslatePipe, NgStyle],
    templateUrl: './price-state.component.html',
    styleUrl: './price-state.component.scss'
})
export class PriceStateComponent {
  public stepsService = inject(StepsService);
  private languageService = inject(LanguageService);
  private formService = inject(FormService);

  inOnlinePaymentStep = computed(() => {
    if (this.formService.form().isReservation) return false;
    return this.stepsService.currentStep() === this.stepsService.stepsData.bookingHandler.step;
  });

  areDifferentRentalPoints = computed(() => {
    const startRental = this.formService.form().startRental;
    const endRental = this.formService.form().endRental;
    if (!startRental || !startRental?.accountId || !endRental || !endRental?.accountId) return false;
    return startRental.accountId !== endRental.accountId;
});

  lang = computed(() => this.languageService.currentLanguage());

  price = computed(() => this.formService.form().price);
  discountedPrice = computed(() => this.formService.form().discountedPrice || 0);
  differentRentalPointsPrice = computed(() => this.formService.form().differentRentalPointsPrice || 0);
  onlineDiscountedPrice = computed(() => this.formService.form().onlineDiscountedPrice);

}
